import styled from "styled-components";

export const AnimationDiv = styled.div`
  animation: slide-right 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

  @keyframes slide-right {
    0% {
      transform: translateX(-100px);
    }
    100% {
      transform: translateX(0px);
    }
  }
`;
